import {LogService} from '../service/logService'
const oldLog = console.log;

let currentApp = '';


const logger = (level: string) => {
    return ( event:any) => {
        LogService.logMessage(currentApp, level, event);
        oldLog.call(console, event);
    }
}

window.console.error = logger("error");
window.console.warn = logger( "warn");
window.console.info =  logger("info");
window.console.log = logger("info");

export const setAppName = (appName:string) => {
    currentApp = appName;
}
